import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root',
})
export class BillingDiscountService {
    discount='';
    public discountName= new BehaviorSubject<string>(
            this.discount
    );
    constructor(
        private http: HttpClient,
      ) {}

    setDiscountName(discount){
        this.discountName.next(discount)
    }
    getDiscountName(){
        return this.discountName.asObservable();
    }
}